<template>
  <div class="c-base-input-switch">
    <p class="label">
      {{ label }}
      <a
        v-if="tooltip"
        height="24px"
        class="tooltip is-tooltip-multiline"
        :data-tooltip="tooltip"
      >
        <base-icon class="icon" name="painel/info-solid" />
      </a>
    </p>
    <div class="switch">
      <span v-if="switcher">Sim</span>
      <span v-else>Não</span>
      <b-switch v-model="switcher" @input="toggle" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      switcher: false,
    }
  },

  mounted() {
    this.switcher = this.checked
  },

  methods: {
    toggle(changed) {
      this.$emit('change', changed)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-input-switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid $neutrallight;

  .label {
    display: flex;
    align-items: center;
    flex: 1;
    margin: 0;
    font-size: 16px;
    color: $neutral;

    > .tooltip {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 4px;
      color: $neutral;
    }
  }

  .switch {
    display: flex;
    flex-direction: row;
    align-items: center;

    > span {
      margin-right: 8px;
      font-size: 14px;
      font-weight: bold;
      color: $primary;
    }
  }
}
</style>
